module.exports = __webpack_public_path__ + "static/media/65.c14ad8b9.png";